import smartParkService from "../axios";

export const fieldsService = async () => {
  try {
    const response = await smartParkService.get("api/citizen/dashboard", {
      headers: {
        "x-access-token": "citizen",
      },
    });
    const result = transformData(response.data.data.data);

    const array = response.data.data.data.map((park) => {
      return {
        park_id: park.id,
        park_name: park.name,
        status: park.status,
        field_data: park.locations.fields.map((field, index) => {
          return {
            field_id: field.FieldID,
            field_name: field.FieldName,
            field_status: field.FieldStatus,
            group_name: field.FieldGroup,
            finalStatus: park.locations.counters[index].countervalue,
            counterId: park.locations.counters[index].counterid,
          };
        }),
      };
    });

    return result;
  } catch (error) {
    console.error("Error fetching fields:", error);
    throw error;
  }
};

const transformData = (data) => {
  return data.map((item) => {
    const mergedFields = item.locations.fields.map((field) => {
      const correspondingCounter = item.locations.counters.find(
        (counter) => counter.fieldid === field.FieldID
      );

      return {
        park_id: item.id,
        field_id: field.FieldID,
        field_name: field.FieldName,
        field_type: "field",
        field_status: field.FieldStatus,
        DisplayOrder: field.DisplayOrder,
        group_name: field.FieldGroup,
        finalStatus: correspondingCounter
          ? `${correspondingCounter.countervalue} Cars`
          : "Not Available",
        counter_name: correspondingCounter
          ? correspondingCounter.countername
          : "Unknown",
        counter_id: correspondingCounter
          ? correspondingCounter.counterid
          : "Unknown",
        last_updated_on: correspondingCounter
          ? correspondingCounter.LastUpdatedOn
          : null,
      };
    });

    return {
      park_id: item.id,
      park_name: item.name,
      short_name: item.shortname,
      img_path: null,
      status: item.status || "N.A",
      field_data: mergedFields,
    };
  });
};
